import styles from './Spinner.module.scss';

export default function Spinner({ size = 20, color = '#fff' }) {
  const scale = size / 20;
  
  return (
    <div 
      className={styles.ispinner}
      style={{ 
        transform: `scale(${scale})`,
        transformOrigin: 'center center'
      }}
    >
      <div className={styles.ispinnerBlade} style={{ backgroundColor: color }} />
      <div className={styles.ispinnerBlade} style={{ backgroundColor: color }} />
      <div className={styles.ispinnerBlade} style={{ backgroundColor: color }} />
      <div className={styles.ispinnerBlade} style={{ backgroundColor: color }} />
      <div className={styles.ispinnerBlade} style={{ backgroundColor: color }} />
      <div className={styles.ispinnerBlade} style={{ backgroundColor: color }} />
      <div className={styles.ispinnerBlade} style={{ backgroundColor: color }} />
      <div className={styles.ispinnerBlade} style={{ backgroundColor: color }} />
    </div>
  );
}
